/**
* MCF-FIELD
*
* @since      1.0
* @package    Mindfolio
* @subpackage Mind Contact Form
* @author     Webmajstr <info@webmajstr.cz>
* @copyright  Copyright (c) 2021 Webmajstr
* @license    GPL2+
*/

import validation_types from './types';



export default class MCF_Field {


	/**	CONSTRUCTOR - Add a new action to the collection to be registered with WordPress.
	* 
	*	@since    1.0.0
	*	@param el_field Container HTML element consists of relevant <elements with class <'mcf-input'> and <'mcf-message'>
	*	@param mcf_err_field Container HTML element for global error messages.
	*	@param email_reg Object with data validation regular expressions. { key:regexp_slug -> value }
	*/

	Val_regs: validation_types;

	el_field: HTMLDivElement;

	name: string;

	type: string;

	el_input: HTMLInputElement;

	el_noval: HTMLSpanElement;

	el_valid: HTMLSpanElement;


	constructor ( el_field:HTMLDivElement, Val_regs:validation_types ) {

		this.Val_regs  = Val_regs;

		this.el_field = el_field; // TODO check whether is a HTML element

		this.name = el_field.getAttribute( 'wmsData' );
			
		this.el_input = el_field.querySelector( '.wms-input' ); 

		this.type = this.el_input.getAttribute( 'type' );
		
		this.el_noval = el_field.querySelector( '.wms-noval' );

		this.el_valid = el_field.querySelector( '.wms-wrongval' ) || null;

	}

	/**	RESET  - Resets the form before submit 
	 *	@since    1.0.0
	 */

	reset ():void {
		
		this.el_input.classList.remove( 'is-invalid-input' );
		
		if( this.el_noval )
			this.el_noval.style.display = 'none';

		if( this.el_valid )
			this.el_valid.style.display = 'none';
	}
	empty ():void {
		this.el_input.value = '';
	}

	/**	CHECK  - Checks the field for relevant data.
	 *	@since    1.0.0
	 */

	check ():boolean {


		const val = this.get_value();
		const valid:string = this.el_field.getAttribute ( 'validation' );
		
		this.reset();

		if ( !val && this.el_noval ) { // if is empty or not checked 

			console.log( 'field ' +this.name+ 'is empty' );

			this.el_noval.style.display = 'block';

			this.el_input.classList.add( 'is-invalid-input' );

			return false;
		} 
		else if ( this.el_valid && valid ) { // if has validation condition

			const v:RegExp = this.Val_regs[ valid as keyof validation_types ] ;

			if( !v.test( val as string ) ) {

				this.el_valid.style.display = 'block';

				this.el_input.classList.add( 'is-invalid-input' );

				return false;
			}	
		}
			
		return true;

	}

	/**	get_value  - Returns string for texts and boolean for checkboxes.
	 *	@since    1.3.0
	 *	@return string | boolean
	 */
	get_value ():string | boolean {

		if ( this.type && this.type == 'checkbox' )
			return this.el_input.checked;

		else
			return this.el_input.value;

	}

}